import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SectionHeading, EASE } from "./Reveal";

const items = [
  "Productos originales",
  "Precios competitivos",
  "Compras por volumen",
  "Entregas nacionales",
  "Garantía oficial",
  "Facturación",
  "Seguimiento de pedidos",
  "Atención personalizada",
  "Respuesta rápida",
  "Amplio catálogo de marcas",
];

export default function Expectations() {
  return (
    <section id="expectativas" className="relative py-24 md:py-36 bg-white" data-testid="expectations-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_1.2fr] gap-16 items-start">
        <div className="lg:sticky lg:top-32">
          <SectionHeading
            num="09"
            chapter="¿Qué puede esperar de eClick?"
            id="expectativas"
            title={<>Compromisos que se <span className="text-ecamber">cumplen</span></>}
            sub="Indicadores de servicio que forman parte de cada relación comercial con eClick México."
          />
        </div>
        <div className="space-y-4">
          {items.map((it, i) => (
            <motion.div
              key={it}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: EASE }}
              className="group flex items-center gap-5 rounded-2xl border border-ecnavy/10 bg-white px-6 py-4 soft-shadow hover:border-ecamber/50 transition-colors duration-300"
              data-testid={`expectation-item-${i}`}
            >
              <span className="inline-flex h-9 w-9 shrink-0 rounded-full bg-ecamber text-ecdeep items-center justify-center">
                <Check size={17} strokeWidth={3} />
              </span>
              <span className="font-medium text-ecdeep text-sm md:text-base flex-1">{it}</span>
              <div className="hidden sm:block w-28 h-1.5 rounded-full bg-ecnavy/8 overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: "100%" }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.1, delay: 0.3 + i * 0.05, ease: EASE }}
                  className="h-full rounded-full bg-gradient-to-r from-ecnavy to-ecamber"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
